// extracted by mini-css-extract-plugin
export default {"root":"DeleteModal_root__VBpQO","container":"DeleteModal_container__3y+u2"};